import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <div className="pt-28 md:pt-32 pb-20 bg-[#F9F6F0]" data-testid="contact-page">
      <div className="max-w-[800px] mx-auto px-6">
        <h1
          className="text-3xl md:text-4xl font-semibold text-slate-900 text-center mb-3"
          data-testid="contact-title"
        >
          Contact Us
        </h1>
        <p className="text-sm text-slate-500 text-center mb-10">
          We are happy to help with any question about your order, our products, or our policies.
        </p>

        <div className="space-y-8 text-base leading-relaxed text-slate-700">
          <section data-testid="contact-support">
            <h2 className="text-xl font-medium mt-2 mb-3 text-slate-900">Customer Support</h2>
            <p>
              For questions about orders, shipping, returns, refunds, or general enquiries, please email our
              customer support team. We aim to respond within 1–2 business days.
            </p>
            <div className="mt-4">
              <p className="font-medium text-slate-900">Email</p>
              <a
                href="mailto:customerservice@blessingsconnection.com"
                className="text-slate-900 underline hover:text-[#7A2021]"
                data-testid="contact-email"
              >
                customerservice@blessingsconnection.com
              </a>
            </div>
          </section>

          <section data-testid="contact-business" className="border-t border-slate-200 pt-8">
            <h2 className="text-xl font-medium mb-3 text-slate-900">Business Details</h2>

            <div className="space-y-4">
              <div>
                <p className="text-sm font-medium text-slate-500 uppercase tracking-wide">Company</p>
                <p className="mt-1 text-slate-800" data-testid="contact-company">
                  Blessings Connection LLC
                </p>
              </div>

              <div>
                <p className="text-sm font-medium text-slate-500 uppercase tracking-wide">
                  Business Address
                </p>
                <address className="mt-1 not-italic text-slate-800" data-testid="contact-address">
                  Blessings Connection LLC<br />
                  5830 E 2nd St, Ste 7000 #24510<br />
                  Casper, WY 82609<br />
                  United States
                </address>
              </div>

              <div>
                <p className="text-sm font-medium text-slate-500 uppercase tracking-wide">Business Hours</p>
                <p className="mt-1 text-slate-800">
                  Monday to Friday, 9:00 AM – 5:00 PM (US Central Time)
                </p>
                <p className="text-sm text-slate-500">
                  Emails received outside of business hours will be answered on the next business day.
                </p>
              </div>
            </div>
          </section>

          <section className="border-t border-slate-200 pt-8" data-testid="contact-links">
            <h2 className="text-xl font-medium mb-3 text-slate-900">Helpful Links</h2>
            <p className="mb-4">
              Before contacting us, you may find your answer in one of the following pages.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/faq"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                FAQ
              </Link>
              <Link
                to="/shipping"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Shipping policy
              </Link>
              <Link
                to="/returns"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Return policy
              </Link>
              <Link
                to="/privacy"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Privacy policy
              </Link>
              <Link
                to="/terms"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Terms &amp; conditions
              </Link>
            </div>
          </section>

          <div className="border-t border-slate-200 pt-6 mt-6">
            <p className="text-sm text-slate-500">
              Blessings Connection LLC · blessingsconnection.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
